import Events from "@components/events/events";
import EmailCaptureForm from "@components/email-capture-form";
import * as React from 'react';
export default {
  Events,
  EmailCaptureForm,
  React
};